import PropTypes from "prop-types";
import Typography from "@shared/v2/Typography";

const WebsiteHeader = ({ actions, description, title }) => (
  <div className="tw-flex tw-flex-wrap-reverse tw-gap-[32px]">
    <div className="tw-flex-1 tw-min-w-[280px]">
      <Typography variant="headline1">{title}</Typography>
      <Typography variant="body-m" className="tw-mt-[8px]">
        {description}
      </Typography>
    </div>
    <div className="tw-flex tw-flex-wrap tw-gap-[8px]">{actions}</div>
  </div>
);

WebsiteHeader.propTypes = {
  actions: PropTypes.node,
  description: PropTypes.node,
  title: PropTypes.string.isRequired,
};

WebsiteHeader.defaultProps = {
  actions: null,
  description: null,
};

export default WebsiteHeader;
